var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopicTipUpgradeimages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 462 60.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#fff;fill-rule:evenodd;}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#f6f7f8;}.cls-8{font-size:10px;font-family:Muli;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(305.5 2.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 156,
    height: 58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(305.5 2.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 0.79,
    width: 155,
    height: 56.95
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(305.5 2.21)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M6.5,45.46a2,2,0,0,1-2-2V4.79a2,2,0,0,1,2-2h143a2,2,0,0,1,2,2V43.46a2,2,0,0,1-2,2H84L79.56,51a2,2,0,0,1-2.82.3,2.13,2.13,0,0,1-.3-.3L72,45.46Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("image", {
    x: 305.5,
    y: 2.21,
    width: 156,
    height: 58,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJwAAAA6CAYAAABF/TC+AAAACXBIWXMAAAsSAAALEgHS3X78AAACvElEQVR4Xu2dwW7jMAwFn+Jk9/8/t21c7cFiRMly4hQoD6sZgLDjJhdiREkuIKacswCiuNpNSil1f+s/A7xDU8lyqWwp5+xlS4MAeJc8COWc86PCqQp2kbSU60VIB++RJX2XWMvVnqsXbinPLJAO3sHLdnexqhPOqpsJ91fSTVU6hIMzmHB3SV/dsySpmVKtmt0k/dEmnRcO6eAZtlYz4ZIGU+u1bBh8hVu0SWdBhYOz+GrmK13S9iIkjTYNtmFY3D3CwRmyqmx+/f/wxwsn90cfFwGcI6lK18uWpGOZqGjwK1C9IBSEg1AQDkJBOAgF4SAUhINQEA5CQTgIBeEgFISDUBAOQkE4CAXhIBSEg1AQDkJBOAgF4SAUhINQEA5CQTgIBeEgFISDUBAOQkE4CAXhIBSEg1AQDkJBOAgF4SAUhINQEA5CORKO9jTwK/TCPZo4uHvkg7OMGoJ4n5ojV/0p1HbqtDV1mPFEzHRwPSIfXGdi1BSkKVrXnHNOKfWy+XP2L3qd7P8NL9lFdSY4yoPPnyVZmk86y8GXakOQRz761kdZVbbP8mzVfML1si16fqK7H6gWs0pnubCC5bvQNFOqT5pVtm/VJEtzSSdV2a7a+lVk7Tvz+AT3SbblyCzYwOpnyWYA9hXOyqEl0ZI7m2y+ut3UViyTTmpH82eJXZInol+a7fIwEs5+tGpO2aRWuEdjMtV8+NFsS5CPEjMLJ1V/ep8kFeHKxsES6b8wo2xSFWtROzVaPpZyXdXK9qHBumVCdutXa9B77R848ZofTIgfgMlF1li42afTIeaV0bc+2n1hVkqTbKtufSvGXridbORxzE44aDDB7u7zqlY434iWyvaCxEA8piwvpHYT4V8E24ve3QtOwRCEe0EnnYnnaXZiyPYchDuBk04a/6dhuyGZL0G4H2ACItj7/AO0KDh0ZljXGQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M-303.5,45.46a2,2,0,0,1-2-2V4.79a2,2,0,0,1,2-2h143a2,2,0,0,1,2,2V43.46a2,2,0,0,1-2,2H-226L-230.44,51a2,2,0,0,1-2.82.3,2.13,2.13,0,0,1-.3-.3L-238,45.46Z",
    transform: "translate(305.5 2.21)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 305,
    width: 157,
    height: 58.95
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(330.76 21.21)"
  }, "Upgrade your account "), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(327.65 34.21)"
  }, "to start sending images")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopicTipUpgradeimages);
export default __webpack_public_path__ + "static/media/TopicTip_Upgrade images.45d1af728606b874a81dc098c4d2ca43.svg";
export { ForwardRef as ReactComponent };